import { bootstrapApplication } from '@angular/platform-browser';
import { addIcons } from 'ionicons';
import {
  mailOutline,
  lockClosedOutline,
  eyeOutline,
  eyeOffOutline,
  storefrontOutline,
  businessOutline,
  pricetagOutline,
  documentTextOutline,
  mapOutline,
  callOutline,
  timeOutline,
  navigateOutline,
  cashOutline,
  locateOutline,
  arrowForwardOutline,
  bicycleOutline,
  logOutOutline,
  chatboxEllipsesOutline,
  notificationsOffOutline,
  notificationsOutline,
  settingsOutline,
  addCircleOutline,
  megaphoneOutline,
  flashOutline,
  sparklesOutline,
  closeOutline,
  imageOutline,
  saveOutline,
  cloudUploadOutline,
  trashOutline,
  documentOutline,
  fastFoodOutline,
  walletOutline,
  receiptOutline,
  addOutline,
  speedometerOutline,
  createOutline,
  closeCircleOutline,
  statsChartOutline,
  personOutline,
  repeatOutline,
  cartOutline,
  flameOutline,
  checkmarkDoneOutline,
  gridOutline,
  cubeOutline,
  warningOutline,
  listOutline,
  refreshOutline,
  searchOutline,
  checkmarkCircleOutline,
  informationCircleOutline,
  layersOutline,
  helpCircleOutline,
} from 'ionicons/icons';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Register all Ionicons used in the vendor app so they render correctly
addIcons({
  mailOutline,
  lockClosedOutline,
  eyeOutline,
  eyeOffOutline,
  storefrontOutline,
  businessOutline,
  pricetagOutline,
  documentTextOutline,
  mapOutline,
  callOutline,
  timeOutline,
  navigateOutline,
  cashOutline,
  locateOutline,
  arrowForwardOutline,
  bicycleOutline,
  logOutOutline,
  chatboxEllipsesOutline,
  notificationsOffOutline,
  notificationsOutline,
  settingsOutline,
  addCircleOutline,
  megaphoneOutline,
  flashOutline,
  sparklesOutline,
  closeOutline,
  imageOutline,
  saveOutline,
  cloudUploadOutline,
  trashOutline,
  documentOutline,
  fastFoodOutline,
  walletOutline,
  receiptOutline,
  addOutline,
  speedometerOutline,
  createOutline,
  closeCircleOutline,
  statsChartOutline,
  personOutline,
  repeatOutline,
  cartOutline,
  flameOutline,
  checkmarkDoneOutline,
  gridOutline,
  cubeOutline,
  warningOutline,
  listOutline,
  refreshOutline,
  searchOutline,
  checkmarkCircleOutline,
  informationCircleOutline,
  layersOutline,
  helpCircleOutline,
});

console.log('[Vendor App] Starting bootstrap...');
console.log('[Vendor App] App config:', appConfig);

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    console.log('[Vendor App] ✅ Bootstrap successful');
    console.log('[Vendor App] Router outlet should be rendering now');
  })
  .catch((err) => {
    console.error('[Vendor App] ❌ Bootstrap failed:', err);
    console.error('[Vendor App] Error stack:', err?.stack);
  });
